import { addDays } from 'date-fns/addDays';
import { formatDateQuery } from 'uplisting-frontend/utils';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/base';
import CalendarModel from 'uplisting-frontend/models/calendar';
import { CALENDAR_DATES_PER_PAGE } from 'uplisting-frontend/services/calendar/manager';

interface IFetchCalendarParams {
  start_date: string;
  end_date: string;
  include: string;
  property_id?: string;
}

export interface ICalendarLoadOptions {
  startDate: Date;
  endDate?: Date;
  ids?: string;
}

const include = [
  'rates',
  'rates.property',
  'bookings',
  'bookings.multi_unit',
  'changeovers',
  'unavailabilities',
  'changeovers.booking',
  'changeovers.multi_unit',
].join(',');

export default class CalendarRepositoryService extends BaseRepositoryService<CalendarModel> {
  recordName = 'calendar';
  implementMethods = ['query'];

  public async loadData(options: ICalendarLoadOptions): Promise<CalendarModel> {
    const params = this.#getParams(options);

    return (await this.query(params))[0];
  }

  #getParams(options: ICalendarLoadOptions): IFetchCalendarParams {
    const { startDate, ids } = options;
    const endDate = options.endDate
      ? options.endDate
      : addDays(startDate, CALENDAR_DATES_PER_PAGE - 1);

    const params: IFetchCalendarParams = {
      start_date: formatDateQuery(startDate),
      end_date: formatDateQuery(endDate),
      include,
    };

    if (ids) {
      params.property_id = ids;
    }

    return params;
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/calendar': CalendarRepositoryService;
  }
}
